// Facets, section grids, blogs, awards & reviews for the India Tour Packages pages.

const U = (id, w = 700) =>
  String(id).startsWith("/") ? id : `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const REGION_TABS = [
  { label: "All of India", count: 261 },
  { label: "Rajasthan", count: 32 },
  { label: "Uttar Pradesh", count: 23 },
  { label: "North East", count: 19 },
  { label: "Gujarat", count: 17 },
  { label: "Himachal Pradesh", count: 17 },
  { label: "Kerala", count: 17 },
  { label: "Leh Ladakh", count: 15 },
  { label: "Nainital Mussoorie Corbett", count: 15 },
  { label: "North India", count: 14 },
  { label: "Jammu And Kashmir", count: 16 },
];

export const PRICE_PRESETS = [
  { label: "₹ 0 - ₹ 90,000", min: 0, max: 90000 },
  { label: "₹ 90,000 - ₹ 1.8L", min: 90000, max: 180000 },
  { label: "₹ 1.8L - ₹ 2.7L", min: 180000, max: 270000 },
  { label: "₹ 2.7L above", min: 270000, max: 10000000 },
];

export const DURATION_PRESETS = [
  { label: "3 - 15 Days", min: 3, max: 15 },
  { label: "15 - 27 Days", min: 15, max: 27 },
  { label: "27 - 39 Days", min: 27, max: 39 },
  { label: "39 - 50 Days", min: 39, max: 50 },
];

export const DEPARTURE_CITIES = [
  { label: "Joining / Leaving", count: 136 },
  { label: "Pune", count: 6 },
  { label: "Mumbai", count: 135 },
];

export const JOINING_LEAVING = [
  { label: "Agartala", count: 2 },
  { label: "Port Blair", count: 3 },
  { label: "Srinagar", count: 4 },
  { label: "Jodhpur", count: 4 },
  { label: "Cochin", count: 4 },
  { label: "Amritsar", count: 4 },
  { label: "Thiruvananthapuram", count: 5 },
  { label: "Indore", count: 5 },
  { label: "Bhubaneshwar", count: 5 },
  { label: "Bagdogra", count: 5 },
  { label: "Chandigarh", count: 6 },
  { label: "Lucknow", count: 8 },
  { label: "Leh", count: 8 },
  { label: "Jaipur", count: 8 },
  { label: "Bengaluru", count: 8 },
  { label: "Guwahati", count: 9 },
  { label: "Ahmedabad", count: 15 },
  { label: "Delhi", count: 20 },
];

export const PACKAGE_TYPES = [
  { label: "All", count: 261 },
  { label: "Group Tour", count: 141 },
  { label: "Customized Holidays", count: 95 },
  { label: "Inbound", count: 25 },
];

export const SPECIALITY_TOURS = [
  { label: "Family", count: 78 },
  { label: "Customized Holidays", count: 76 },
  { label: "Women's Special", count: 28 },
  { label: "Inbound", count: 25 },
  { label: "Fixed Date Holiday", count: 17 },
  { label: "Seniors' Special", count: 16 },
  { label: "Pilgrimage", count: 12 },
  { label: "Short Trips", count: 10 },
  { label: "Road Trips", count: 7 },
  { label: "Honeymoon Special", count: 2 },
  { label: "Customized Packages", count: 1 },
];

export const COUNTRIES_FACET = [
  { label: "India", count: 261 },
  { label: "Nepal", count: 1 },
];

export const CITIES_FACET = [
  { label: "Delhi", count: 33 },
  { label: "Jaipur", count: 31 },
  { label: "Udaipur", count: 22 },
  { label: "Ahmedabad", count: 20 },
  { label: "Guwahati", count: 17 },
  { label: "Ayodhya", count: 16 },
  { label: "Agra", count: 15 },
  { label: "Leh", count: 15 },
  { label: "Munnar", count: 15 },
  { label: "Nubra Valley", count: 15 },
];

export const SORT_OPTIONS = [
  "Deals",
  "Price: High to Low",
  "Price: Low to High",
  "Duration: Long to Short",
  "Duration: Short to Long",
];

// ── Section grids ────────────────────────────────────────────────
export const BY_CITY = [
  { name: "Jaipur", tours: 31, image: U("1477587458883-47145ed94245") },
  { name: "Munnar", tours: 15, image: U("/assets/media/wiki-munnar.jpg") },
  { name: "Shimla", tours: 9, image: U("1597074866923-dc0589150358") },
  { name: "Darjeeling", tours: 10, image: U("1544634076-a90160ddf44c") },
  { name: "Varanasi", tours: 15, image: U("/assets/media/wiki-varanasi-ghat.jpg") },
  { name: "Mysore", tours: 11, image: U("/assets/media/wiki-mysore.jpg", 701) },
  { name: "Udaipur", tours: 22, image: U("1599661046289-e31897846e41") },
];

export const BY_STATE = [
  { name: "Rajasthan", tours: 32, image: U("1599661046289-e31897846e41") },
  { name: "Kerala", tours: 17, image: U("1602216056096-3b40cc0c9944") },
  { name: "Himachal Pradesh", tours: 17, image: U("1626621341517-bbf3d9990a23") },
  { name: "Gujarat", tours: 17, image: U("1599661046289-e31897846e41") },
  { name: "Uttar Pradesh", tours: 23, image: U("1564507592333-c60657eea523") },
  { name: "Jammu And Kashmir", tours: 16, image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg" },
  { name: "Sikkim", tours: 12, image: U("1544634076-a90160ddf44c", 701) },
];

export const BY_ZONE = {
  North: [
    { name: "Himachal Pradesh Tour Packages", tours: 20, image: U("1626621341517-bbf3d9990a23") },
    { name: "Jammu And Kashmir Tour Packages", tours: 16, image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg" },
    { name: "Leh Ladakh Tour Packages", tours: 15, image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
    { name: "Amritsar Tour Packages", tours: 13, image: U("/assets/media/royal-amritsar-golden-temple.jpg") },
    { name: "Agra Tour Packages", tours: 15, image: U("1564507592333-c60657eea523") },
    { name: "Delhi Tour Packages", tours: 32, image: U("1564507592333-c60657eea523") },
    { name: "Nainital Mussoorie Corbett Tour Packages", tours: 14, image: U("1597074866923-dc0589150358") },
  ],
  South: [
    { name: "Kerala Tour Packages", tours: 17, image: U("1602216056096-3b40cc0c9944") },
    { name: "Karnataka Tour Packages", tours: 14, image: U("/assets/media/wiki-hampi.jpg") },
    { name: "Tamil Nadu Tour Packages", tours: 12, image: U("/assets/media/wiki-madurai.jpg") },
    { name: "Andaman Tour Packages", tours: 10, image: U("1602216056096-3b40cc0c9944") },
  ],
  "West & Central": [
    { name: "Rajasthan Tour Packages", tours: 32, image: U("1599661046289-e31897846e41") },
    { name: "Gujarat Tour Packages", tours: 17, image: U("1599661046289-e31897846e41") },
    { name: "Goa Tour Packages", tours: 15, image: U("1602216056096-3b40cc0c9944") },
    { name: "Madhya Pradesh Tour Packages", tours: 11, image: U("/assets/media/royal-khajuraho-temple.jpg") },
  ],
  "East & North East": [
    { name: "Sikkim Darjeeling Tour Packages", tours: 12, image: U("1544634076-a90160ddf44c") },
    { name: "Meghalaya Tour Packages", tours: 9, image: U("1544634076-a90160ddf44c") },
    { name: "Assam Tour Packages", tours: 8, image: U("/assets/media/royal-assam-tea-garden.jpg", 701) },
    { name: "Arunachal Pradesh Tour Packages", tours: 6, image: "/assets/media/043-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
  ],
};

export const BY_SEASON = {
  "March to June": [
    { name: "Srinagar", tours: 13, image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg" },
    { name: "Dharamshala", tours: 8, image: U("1626621341517-bbf3d9990a23") },
    { name: "Sikkim Darjeeling", tours: 9, image: U("1544634076-a90160ddf44c") },
    { name: "Gangtok", tours: 9, image: U("1544634076-a90160ddf44c") },
    { name: "Shimla", tours: 9, image: U("1597074866923-dc0589150358") },
    { name: "Dalhousie", tours: 7, image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
  ],
  "July to October": [
    { name: "Leh Ladakh", tours: 15, image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
    { name: "Spiti Valley", tours: 8, image: U("1626621341517-bbf3d9990a23") },
    { name: "Kerala", tours: 17, image: U("1602216056096-3b40cc0c9944") },
    { name: "Meghalaya", tours: 9, image: U("1544634076-a90160ddf44c") },
    { name: "Coorg", tours: 7, image: U("/assets/media/wiki-coorg.jpg") },
    { name: "Goa", tours: 15, image: U("1602216056096-3b40cc0c9944") },
  ],
  "November to February": [
    { name: "Rann of Kutch", tours: 11, image: U("1599661046289-e31897846e41") },
    { name: "Jaipur", tours: 31, image: U("1477587458883-47145ed94245") },
    { name: "Andaman", tours: 10, image: U("1602216056096-3b40cc0c9944") },
    { name: "Udaipur", tours: 22, image: U("1599661046289-e31897846e41") },
    { name: "Varanasi", tours: 15, image: U("/assets/media/wiki-varanasi-aarti.jpg") },
    { name: "Hampi", tours: 8, image: U("/assets/media/wiki-hampi.jpg", 702) },
  ],
};

export const BY_INTEREST_TABS = ["Honeymoon Special", "Women's Special", "Seniors' Special"];

export const BY_DURATION = [
  { label: "1 - 3 Days", tours: 42, image: U("1564507592333-c60657eea523") },
  { label: "4 - 6 Days", tours: 118, image: U("1477587458883-47145ed94245") },
  { label: "7 - 9 Days", tours: 74, image: U("1602216056096-3b40cc0c9944") },
  { label: "10+ Days", tours: 27, image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
];

export const POPULAR_BLOGS = [
  { title: "Why Kashmir Is Called Heaven On Earth", image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg" },
  { title: "The Complete Rajasthan Road Trip Guide", image: U("1599661046289-e31897846e41") },
  { title: "10 Temples You Must Visit In Varanasi", image: U("/assets/media/wiki-varanasi-aarti.jpg") },
  { title: "Kerala Backwaters: A Slow Travel Diary", image: U("1602216056096-3b40cc0c9944") },
  { title: "Ladakh On A Bike: The Ultimate Bucket List", image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
];

export const AWARDS = [
  { title: "India Travel Awards", sub: "Best International Group Tour Operator (West & South)" },
  { title: "FICCI", sub: "Travel & Tourism Excellence Award" },
  { title: "Arthsanket 2019", sub: "Maharashtra's Most Popular Brand Award" },
  { title: "Global India Business Forum", sub: "Global India Business Excellence Award" },
  { title: "CNBC Awaaz", sub: "Travel Company of the Year" },
];

export const TOUR_REVIEWS = [
  { rating: 5, tag: "Family", title: "Highlights of Rajasthan", text: "Very nice experience. All Royal Tours staff was very g...", author: "Vandana", date: "Jul, 2026", managers: "Santosh Dhamke, Saurabh Shinde", image: U("1599661046289-e31897846e41", 300) },
  { rating: 5, tag: "Family", title: "Highlights of Kerala", text: "From the stunning backwaters in Alleppey and the peac...", author: "Manjushree", date: "Jul, 2026", managers: "Santosh Dhamke, Saurabh Shinde", image: U("1602216056096-3b40cc0c9944", 300) },
  { rating: 5, tag: "Honeymoon", title: "Best of Kashmir", text: "10/10 for Umesh Vishe the tour manager for his perfect...", author: "Ninad", date: "Jul, 2026", managers: "Umesh Vishe, Sunil Chand", image: "/assets/media/048-images-unsplash-com-photo-1675185991531-9c2aee461355.jpg" },
  { rating: 5, tag: "Road Trips", title: "Best of Ladakh", text: "Breathtaking landscapes and superbly managed accli...", author: "Rahul", date: "Jun, 2026", managers: "Umesh Vishe", image: "/assets/media/045-images-unsplash-com-photo-1645033393637-9089ab100756.jpg" },
];

export const INDIA_INTRO =
  "The ancient spark of the spiritual land, with ethnic evolutionary life, completely different from anywhere on the globe, is the land where your soul awaits to transcend! What kind of diversity can you expect when visiting India? From snow-clad Himalayan peaks to sun-kissed southern beaches, from the golden Thar desert to the emerald backwaters of Kerala — India is not a single destination, it is a thousand journeys woven into one.";

export const INDIA_FAQS = [
  { q: "Where can I find information about Royal Tours Group tours and products?", a: "Royal Tours Group's website royaltoursgroup.in contains information about all our products, tour categories and services. You can also call our Toll Free number 1800 266 1100 and get all the details about tours and various products from Royal Tours travel advisors." },
  { q: "What type of tours or packages does Royal Tours Group offer?", a: "We offer Group Tours, Customized Holidays, Speciality Tours (honeymoon, women-only, pilgrimage, senior citizens), Corporate & MICE, Inbound India tours and Visa services across India and 60+ countries." },
  { q: "Does Royal Tours Group book train tickets?", a: "Yes — train tickets are arranged as part of our tour packages where rail travel is part of the itinerary. Standalone rail bookings are available on request through our travel desk." },
  { q: "Where can I find the addresses of Royal Tours Group offices or its Sales Partners?", a: "Our Head Office is at Golghar, Gorakhpur, Uttar Pradesh. For a complete list of branch offices and authorised Sales Partners across India, please call 1800 266 1100 or email holiday@royaltoursgroup.in." },
  { q: "How many travellers will be there as a part of a group tour?", a: "Our small-group escorted tours typically range between 18 and 35 guests, ensuring a personal experience while keeping the camaraderie of a group. MICE and bespoke groups are sized to the booking." },
];
